import { actionsArrayType } from 'src/components/List/utils';

export const clinicActions: actionsArrayType = ({ itemId }) => [
  {
    icon: 'edit',
    link: '#',
    classes: 'border border-1 border-primary',
    tooltip: 'Editar',
  },
  {
    icon: 'user',
    link: '#',
    classes: 'border border-1 border-primary',
    tooltip: 'Usuarios',
  },
  {
    icon: 'trash',
    link: '',
    classes: 'border border-1 border-primary',
    tooltip: 'Eliminar',
  },
];

export const userActions: actionsArrayType = ({ itemId }) => [
  {
    icon: 'edit',
    link: '',
    classes: 'border border-1 border-primary',
    tooltip: 'Editar',
  },
  {
    icon: 'user',
    link: '',
    classes: 'border border-1 border-primary',
    tooltip: 'Usuarios',
  },
  {
    icon: 'trash',
    link: '',
    classes: 'border border-1 border-primary',
    tooltip: 'Eliminar',
  },
];
